import React from "react";

type CreditCardIconProps = {
  brand?: "discover" | "mastercard" | "visa" | "amex" | string;
  showError?: boolean;
  showPrimary?: boolean;
};

export function CreditCardIcon(props: CreditCardIconProps) {
  const { brand, showError, showPrimary } = props;

  const creditCardMap = (brand: string) =>
    ({
      visa: (
        <>
          <rect
            x="3"
            y="2"
            width="34"
            height="20"
            rx="1.61395"
            fill="#26337A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2296 15.3632L18.2841 8.82142H19.9698L18.9153 15.3632H17.2296Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.0296 8.98199C24.6963 8.8507 24.1721 8.70752 23.5192 8.70752C21.8526 8.70752 20.6795 9.59527 20.6698 10.8665C20.6592 11.8068 21.5069 12.3312 22.146 12.6437C22.8028 12.9641 23.0235 13.1691 23.0209 13.4555C23.0164 13.8936 22.4966 14.0944 22.012 14.0944C21.3371 14.0944 20.9786 13.9956 20.4242 13.7513L20.2074 13.6472L19.9717 15.1115C20.3647 15.2937 21.0934 15.4519 21.8496 15.4602C23.6208 15.4602 24.7716 14.5831 24.7851 13.2257C24.7912 12.48 24.342 11.9149 23.3693 11.4482C22.7802 11.1449 22.4187 10.9439 22.4228 10.6369C22.4232 10.3651 22.7282 10.074 23.3884 10.074C23.9398 10.0651 24.3389 10.1924 24.65 10.3253L24.8013 10.4001L25.0296 8.98199Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M27.2741 13.0439C27.4138 12.6678 27.9456 11.2153 27.9456 11.2153C27.9358 11.2326 28.0845 10.8364 28.1697 10.5912L28.2834 11.1554C28.2834 11.1554 28.6069 12.7168 28.6735 13.0439C28.4111 13.0439 27.6033 13.0439 27.2741 13.0439ZM29.3537 8.82809H28.051C27.6469 8.82809 27.3445 8.94383 27.1675 9.37036L24.6642 15.3655H26.4347C26.4347 15.3655 26.7235 14.559 26.7891 14.382C26.9822 14.382 28.7025 14.3854 28.9481 14.3854C28.9986 14.6137 29.1533 15.3655 29.1533 15.3655H30.7179L29.3537 8.82809Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.8155 8.82693L14.1656 13.2868L13.9889 12.3802C13.6814 11.3357 12.7244 10.2035 11.6539 9.63623L13.1632 15.3575L14.9472 15.3564L17.6017 8.82693H15.8155Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.6341 8.82172H9.91579L9.89342 8.95726C12.0086 9.49914 13.408 10.8071 13.9889 12.3795L13.3982 9.37365C13.2963 8.9591 13.0001 8.83621 12.6341 8.82172Z"
            fill="#EC982D"
          />
        </>
      ),
      mastercard: (
        <>
          <rect
            x="3"
            y="2"
            width="34"
            height="20"
            rx="1.61395"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.9486 12.2555C21.9486 15.952 18.9523 18.9483 15.2558 18.9483C11.5593 18.9483 8.56268 15.952 8.56268 12.2555C8.56268 8.55901 11.5593 5.56244 15.2558 5.56244C18.9523 5.56244 21.9486 8.55901 21.9486 12.2555Z"
            fill="#CC0000"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.2415 5.56244C22.5118 5.56244 20.9362 6.21853 19.7482 7.29485C19.5065 7.51422 19.2809 7.75114 19.0726 8.0034H20.4249C20.6096 8.22827 20.7798 8.46467 20.9351 8.71228H18.5623C18.4204 8.93979 18.2913 9.17618 18.1767 9.42115H21.3206C21.428 9.65056 21.5226 9.88685 21.604 10.1297H17.8932C17.816 10.3605 17.7508 10.597 17.6988 10.8382H21.7982C21.8964 11.2951 21.9486 11.7691 21.9486 12.2555C21.9486 12.9985 21.8275 13.7137 21.604 14.3817H17.8932C17.9746 14.6243 18.0692 14.8609 18.1764 15.0906H21.3206C21.2057 15.335 21.0773 15.5716 20.9345 15.7994H18.5623C18.717 16.0463 18.8875 16.283 19.0726 16.5075H20.4245C20.2167 16.76 19.9908 16.9969 19.7484 17.2163C20.9363 18.2926 22.5118 18.9483 24.2415 18.9483C27.9379 18.9483 30.9343 15.952 30.9343 12.2555C30.9343 8.55933 27.9379 5.56244 24.2415 5.56244Z"
            fill="#FF9900"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.6928 12.9882C13.6166 12.9795 13.583 12.9767 13.5306 12.9767C13.1187 12.9767 12.9105 13.1181 12.9105 13.3972C12.9105 13.5691 13.0121 13.6783 13.1708 13.6783C13.4668 13.6783 13.6802 13.3965 13.6928 12.9882ZM14.2214 14.2185C14.1245 14.2185 13.6191 14.2185 13.6191 14.2185L13.633 13.9323C13.4494 14.1583 13.2043 14.2662 12.8714 14.2662C12.4778 14.2662 12.2077 13.9588 12.2077 13.5121C12.2077 12.8397 12.6772 12.4477 13.4833 12.4477C13.5659 12.4477 13.6715 12.4553 13.7796 12.4689C13.802 12.3777 13.8079 12.339 13.8079 12.2898C13.8079 12.1071 13.6814 12.0385 13.342 12.0385C12.9865 12.0349 12.6933 12.1235 12.5728 12.163C12.5805 12.1171 12.6736 11.542 12.6736 11.542C13.0356 11.4356 13.2744 11.3959 13.5432 11.3959C14.1672 11.3959 14.4978 11.676 14.497 12.2054C14.4983 12.3475 14.4747 12.5221 14.4382 12.7525C14.3752 13.1523 14.2398 14.0098 14.2214 14.2185Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9036 14.2185H11.1769L11.5934 11.6089L10.6638 14.2185H10.1687L10.1075 11.6235L9.66999 14.2185H8.98988L9.55798 10.8235H10.6029L10.666 12.7238L11.3035 10.8235H12.4656L11.9036 14.2185Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.1393 12.9882C25.063 12.9795 25.0298 12.9767 24.9776 12.9767C24.5654 12.9767 24.3573 13.1181 24.3573 13.3972C24.3573 13.5691 24.4586 13.6783 24.6176 13.6783C24.9135 13.6783 25.1269 13.3965 25.1393 12.9882ZM25.6681 14.2185C25.5711 14.2185 25.0661 14.2185 25.0661 14.2185L25.0797 13.9323C24.8961 14.1583 24.6512 14.2662 24.3185 14.2662C23.9243 14.2662 23.6546 13.9588 23.6546 13.5121C23.6546 12.8397 24.1243 12.4477 24.9302 12.4477C25.0127 12.4477 25.118 12.4553 25.2262 12.4689C25.2488 12.3777 25.2546 12.339 25.2546 12.2898C25.2546 12.1071 25.1281 12.0385 24.7887 12.0385C24.4332 12.0349 24.1401 12.1235 24.0192 12.163C24.0272 12.1171 24.1206 11.542 24.1206 11.542C24.4824 11.4356 24.7214 11.3959 24.9897 11.3959C25.6142 11.3959 25.9443 11.676 25.9437 12.2054C25.9449 12.3475 25.9216 12.5221 25.8849 12.7525C25.822 13.1523 25.6863 14.0098 25.6681 14.2185Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.4506 14.1764C17.2516 14.2391 17.0966 14.2661 16.9285 14.2661C16.5571 14.2661 16.3543 14.0527 16.3543 13.6595C16.3492 13.5375 16.4078 13.2165 16.4539 12.9237C16.496 12.6657 16.7691 11.0396 16.7691 11.0396H17.4912L17.4069 11.4575H17.8432L17.7447 12.1211H17.3069C17.223 12.646 17.1034 13.3001 17.102 13.3869C17.102 13.5292 17.178 13.5914 17.3509 13.5914C17.4337 13.5914 17.4978 13.583 17.5468 13.5654L17.4506 14.1764Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.665 14.1541C19.4168 14.23 19.1777 14.267 18.9239 14.2662C18.1153 14.2651 17.6938 13.8431 17.6938 13.0345C17.6938 12.0908 18.23 11.3959 18.958 11.3959C19.5534 11.3959 19.9338 11.7849 19.9338 12.3948C19.9338 12.5975 19.9078 12.7951 19.8447 13.0739H18.4064C18.3578 13.4745 18.614 13.6413 19.0345 13.6413C19.2926 13.6413 19.526 13.588 19.7852 13.4677L19.665 14.1541ZM19.259 12.5174C19.2631 12.4598 19.3355 12.0245 18.9227 12.0245C18.6929 12.0245 18.5282 12.1999 18.4615 12.5174H19.259Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.6572 12.3305C14.6572 12.6794 14.8264 12.9202 15.2103 13.1012C15.5045 13.2397 15.5503 13.2806 15.5503 13.4059C15.5503 13.5778 15.4204 13.6559 15.133 13.6559C14.9161 13.6559 14.7145 13.6218 14.4819 13.5466C14.4819 13.5466 14.3866 14.1554 14.382 14.1845C14.5472 14.2203 14.6944 14.2536 15.1382 14.2662C15.9048 14.2662 16.2589 13.9742 16.2589 13.3433C16.2589 12.964 16.1109 12.7414 15.7468 12.5738C15.4423 12.4341 15.4071 12.4028 15.4071 12.274C15.4071 12.1247 15.528 12.0485 15.7627 12.0485C15.9054 12.0485 16.1001 12.0637 16.2849 12.0898L16.3882 11.4495C16.2001 11.4196 15.9148 11.3959 15.7487 11.3959C14.936 11.3959 14.6545 11.8203 14.6572 12.3305Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M23.1988 11.4687C23.4007 11.4687 23.5891 11.5211 23.8482 11.652L23.9672 10.9152C23.8603 10.8733 23.4858 10.6278 23.1685 10.6278C22.6824 10.6278 22.2709 10.8694 21.9821 11.2672C21.5602 11.1276 21.3867 11.4098 21.1743 11.6911L20.9855 11.7351C20.9998 11.6426 21.0128 11.5507 21.0087 11.4575H20.341C20.2501 12.3122 20.0886 13.1776 19.9622 14.0327L19.9291 14.2184H20.656C20.7773 13.43 20.8437 12.9253 20.8841 12.5835L21.1578 12.4318C21.1989 12.2794 21.3266 12.2282 21.5834 12.2345C21.5499 12.4145 21.5317 12.6041 21.5317 12.8003C21.5317 13.7037 22.0197 14.2661 22.8016 14.2661C23.0031 14.2661 23.1761 14.2396 23.444 14.1667L23.5714 13.3931C23.3304 13.5114 23.1332 13.5672 22.9543 13.5672C22.5319 13.5672 22.2762 13.2552 22.2762 12.74C22.2762 11.9923 22.6561 11.4687 23.1988 11.4687Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.3506 10.8235L29.1891 11.8044C28.9908 11.543 28.7774 11.3537 28.4956 11.3537C28.129 11.3537 27.7953 11.6316 27.5768 12.041C27.2725 11.9778 26.958 11.8705 26.958 11.8705L26.9578 11.8731C26.982 11.6443 26.9923 11.5051 26.9898 11.4575H26.3223C26.2317 12.3123 26.07 13.1777 25.9437 14.0327L25.9102 14.2185H26.6374C26.7356 13.5813 26.8106 13.0516 26.8659 12.6321C27.1144 12.4075 27.2388 12.2121 27.4894 12.2248C27.3782 12.4937 27.3134 12.8031 27.3134 13.1207C27.3134 13.8106 27.6622 14.2662 28.1907 14.2662C28.457 14.2662 28.6613 14.1742 28.8606 13.9614L28.8263 14.2182H29.5138L30.0673 10.8235H29.3506ZM28.442 13.5806C28.1947 13.5806 28.0694 13.3972 28.0694 13.0363C28.0694 12.4936 28.3035 12.1089 28.633 12.1089C28.8827 12.1089 29.0181 12.2989 29.0181 12.6496C29.0181 13.197 28.7801 13.5806 28.442 13.5806Z"
            fill="#000066"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1126 14.0169H11.3861L11.8025 11.4073L10.8731 14.0169H10.3778L10.3167 11.4225L9.87909 14.0169H9.19899L9.76708 10.6223H10.812L10.8412 12.7238L11.5462 10.6223H12.6747L12.1126 14.0169Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.9019 12.7872C13.8258 12.7783 13.7922 12.7759 13.7398 12.7759C13.3279 12.7759 13.1196 12.917 13.1196 13.1959C13.1196 13.3675 13.2213 13.4774 13.3801 13.4774C13.676 13.4774 13.8894 13.1957 13.9019 12.7872ZM14.4304 14.0169C14.3336 14.0169 13.8284 14.0169 13.8284 14.0169L13.8422 13.731C13.6586 13.9568 13.4135 14.0648 13.0806 14.0648C12.6869 14.0648 12.4169 13.757 12.4169 13.3105C12.4169 12.638 12.8866 12.2464 13.6926 12.2464C13.775 12.2464 13.8806 12.2539 13.9888 12.2679C14.0112 12.1765 14.0171 12.1377 14.0171 12.0883C14.0171 11.9056 13.8906 11.8376 13.5512 11.8376C13.1956 11.8334 12.9025 11.9219 12.782 11.9614C12.7897 11.9157 12.8828 11.3406 12.8828 11.3406C13.2448 11.2344 13.4836 11.1943 13.7524 11.1943C14.3763 11.1943 14.7068 11.4747 14.7062 12.004C14.7074 12.1458 14.684 12.3213 14.6474 12.5511C14.5843 12.9505 14.4489 13.8086 14.4304 14.0169Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.1762 10.7137L24.0572 11.4504C23.7977 11.32 23.6098 11.2672 23.4082 11.2672C22.8657 11.2672 22.4851 11.7915 22.4851 12.5393C22.4851 13.0545 22.7409 13.3658 23.1633 13.3658C23.3423 13.3658 23.54 13.3105 23.7804 13.1917L23.6527 13.9653C23.3852 14.0382 23.2121 14.0649 23.0107 14.0649C22.2283 14.0649 21.741 13.5024 21.741 12.5992C21.741 11.3856 22.4147 10.5374 23.3776 10.5374C23.6949 10.5374 24.0696 10.6718 24.1762 10.7137Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M25.3483 12.7872C25.2726 12.7783 25.2388 12.7759 25.1866 12.7759C24.7749 12.7759 24.5664 12.917 24.5664 13.1959C24.5664 13.3675 24.6681 13.4774 24.8267 13.4774C25.1226 13.4774 25.3361 13.1957 25.3483 12.7872ZM25.8772 14.0169C25.7805 14.0169 25.2752 14.0169 25.2752 14.0169L25.2889 13.731C25.1052 13.9568 24.8602 14.0648 24.5276 14.0648C24.1334 14.0648 23.8638 13.757 23.8638 13.3105C23.8638 12.638 24.333 12.2464 25.1393 12.2464C25.2217 12.2464 25.327 12.2539 25.4351 12.2679C25.4577 12.1765 25.4636 12.1377 25.4636 12.0883C25.4636 11.9056 25.3374 11.8376 24.9978 11.8376C24.6425 11.8334 24.3495 11.9219 24.2287 11.9614C24.2363 11.9157 24.3295 11.3406 24.3295 11.3406C24.6916 11.2344 24.9302 11.1943 25.199 11.1943C25.8229 11.1943 26.1536 11.4747 26.1528 12.004C26.1543 12.1458 26.1307 12.3213 26.0941 12.5511C26.0312 12.9505 25.8958 13.8086 25.8772 14.0169Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.6596 13.9751C17.4608 14.0377 17.3056 14.0649 17.1377 14.0649C16.7662 14.0649 16.5633 13.8513 16.5633 13.4586C16.5583 13.3361 16.617 13.0156 16.6632 12.7225C16.705 12.4643 16.9782 10.8384 16.9782 10.8384H17.7005L17.616 11.2562H17.9868L17.888 11.9196H17.516C17.4321 12.4451 17.3125 13.0987 17.311 13.1855C17.311 13.3283 17.3873 13.39 17.56 13.39C17.6428 13.39 17.7068 13.3819 17.756 13.3639L17.6596 13.9751Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.8744 13.9531C19.6261 14.0292 19.3865 14.065 19.133 14.0648C18.3243 14.0643 17.9031 13.6418 17.9031 12.8332C17.9031 11.8892 18.4392 11.1943 19.1667 11.1943C19.7627 11.1943 20.1429 11.5834 20.1429 12.194C20.1429 12.3963 20.1165 12.5938 20.0541 12.8727H18.6156C18.5668 13.2732 18.8233 13.4404 19.2434 13.4404C19.5017 13.4404 19.735 13.3868 19.9945 13.2663L19.8744 13.9531ZM19.4683 12.3159C19.4722 12.2582 19.5449 11.8231 19.1322 11.8231C18.9022 11.8231 18.7376 11.9988 18.6706 12.3159H19.4683Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8662 12.1289C14.8662 12.4785 15.0356 12.7188 15.4197 12.9C15.7138 13.0383 15.7594 13.0793 15.7594 13.2047C15.7594 13.3768 15.6296 13.4544 15.342 13.4544C15.1253 13.4544 14.9236 13.4208 14.6909 13.3458C14.6909 13.3458 14.5957 13.9542 14.5913 13.9829C14.7563 14.019 14.9036 14.052 15.3472 14.0648C16.114 14.0648 16.4682 13.773 16.4682 13.1421C16.4682 12.7626 16.3199 12.5401 15.9559 12.3729C15.6513 12.2328 15.6163 12.2018 15.6163 12.0728C15.6163 11.9235 15.7371 11.8467 15.972 11.8467C16.1144 11.8467 16.3093 11.8626 16.494 11.8886L16.5974 11.2484C16.4092 11.2187 16.1241 11.1943 15.9579 11.1943C15.145 11.1943 14.8637 11.6189 14.8662 12.1289Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M29.7229 14.0169H29.0357L29.0697 13.76C28.8703 13.9729 28.6661 14.0648 28.3998 14.0648C27.8718 14.0648 27.5224 13.6098 27.5224 12.9191C27.5224 12.0008 28.064 11.2268 28.7047 11.2268C28.9865 11.2268 29.1998 11.3419 29.3986 11.6033L29.5597 10.6223H30.2763L29.7229 14.0169ZM28.651 13.379C28.9895 13.379 29.2271 12.9956 29.2271 12.4488C29.2271 12.0979 29.0918 11.9073 28.8421 11.9073C28.5125 11.9073 28.2785 12.2921 28.2785 12.8351C28.2785 13.1964 28.4039 13.379 28.651 13.379Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.5317 11.2562C26.4408 12.1107 26.2792 12.9761 26.1528 13.8313L26.1197 14.0169H26.8464C27.1064 12.3286 27.1689 11.9991 27.5768 12.0403C27.6416 11.6947 27.7625 11.3921 27.8525 11.2396C27.5482 11.1761 27.3782 11.3481 27.1555 11.6749C27.1733 11.5335 27.2053 11.3963 27.1993 11.2562H26.5317Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.5505 11.2562C20.4592 12.1107 20.2974 12.9761 20.1712 13.8313L20.1382 14.0169H20.8651C21.1252 12.3286 21.1875 11.9991 21.5947 12.0403C21.66 11.6947 21.7811 11.3921 21.8709 11.2396C21.5669 11.1761 21.3966 11.3481 21.1743 11.6749C21.1919 11.5335 21.2241 11.3963 21.2178 11.2562H20.5505Z"
            fill="white"
          />
        </>
      ),

      discover: (
        <>
          <rect
            x="3"
            y="2"
            width="34"
            height="20"
            rx="1.34496"
            fill="#000066"
          />
          <g clipPath="url(#discover-card-clip-path)">
            <rect
              x="3.16667"
              y="2.16667"
              width="33.6667"
              height="19.6667"
              rx="1.16667"
              fill="white"
              stroke="#E6772F"
              strokeWidth="0.333333"
            />
            <mask
              id="discover-card-mask-1"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="3"
              y="2"
              width="34"
              height="20"
            >
              <rect
                x="3.16667"
                y="2.16667"
                width="33.6667"
                height="19.6667"
                rx="1.16667"
                fill="white"
                stroke="white"
                strokeWidth="0.333333"
              />
            </mask>
            <g mask="url(#discover-card-mask-1)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 22H35.6667C36.403 22 37 21.403 37 20.6667V13C37 13 27.8175 19.2174 11 22Z"
                fill="#E6772F"
              />
            </g>
            <mask
              id="discover-card-mask-2"
              mask-type="alpha"
              maskUnits="userSpaceOnUse"
              x="11"
              y="13"
              width="26"
              height="9"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.0385 22H35C35.7363 22 36.3333 21.4031 36.3333 20.6667V13.2327C36.3333 13.2327 27.3998 19.2894 11.0385 22Z"
                fill="white"
              />
            </mask>
            <g mask="url(#discover-card-mask-2)"></g>
          </g>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.09618 11.9406C8.84594 12.1546 8.52738 12.2482 8.01798 12.2482H7.8066V9.69482H8.01798C8.52738 9.69482 8.83372 9.78209 9.09618 10.0067C9.3671 10.2388 9.5299 10.5969 9.5299 10.9672C9.5299 11.3394 9.3671 11.7102 9.09618 11.9406ZM8.17577 9.04077H7.01923V12.9025H8.16872C8.78045 12.9025 9.22201 12.7632 9.60904 12.4558C10.0688 12.0918 10.3416 11.5421 10.3416 10.9726C10.3416 9.83261 9.45156 9.04077 8.17577 9.04077Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.7046 9.04077H11.4889V12.9025H10.7046V9.04077Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.4148 10.5208C12.9414 10.3547 12.803 10.244 12.803 10.0353C12.803 9.79271 13.0503 9.60874 13.3903 9.60874C13.626 9.60874 13.8201 9.699 14.027 9.91956L14.4364 9.40557C14.0981 9.12068 13.6932 8.97644 13.2518 8.97644C12.5376 8.97644 11.9933 9.4519 11.9933 10.0806C11.9933 10.6144 12.2463 10.8852 12.9848 11.1423C13.2935 11.245 13.4503 11.3152 13.5298 11.3627C13.6871 11.46 13.7655 11.5995 13.7655 11.7607C13.7655 12.0748 13.5053 12.3057 13.1537 12.3057C12.7794 12.3057 12.4765 12.1264 12.2952 11.7896L11.7878 12.2598C12.1506 12.7684 12.5854 12.9957 13.1844 12.9957C14.0014 12.9957 14.5771 12.4723 14.5771 11.7268C14.5771 11.1125 14.3101 10.834 13.4148 10.5208Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.8244 10.9726C14.8244 12.1082 15.7559 12.9882 16.9551 12.9882C17.2932 12.9882 17.5831 12.9244 17.9401 12.7632V11.8757C17.6246 12.179 17.3478 12.2987 16.9896 12.2987C16.1972 12.2987 15.6359 11.75 15.6359 10.9672C15.6359 10.2275 16.2153 9.64157 16.9551 9.64157C17.3283 9.64157 17.6135 9.76812 17.9401 10.0759V9.1895C17.5952 9.02261 17.3122 8.95349 16.9712 8.95349C15.779 8.95349 14.8244 9.85073 14.8244 10.9726Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.3162 11.6334L23.24 9.04077H22.382L24.0927 12.9999H24.5147L26.2587 9.04077H25.4074L24.3162 11.6334Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.6158 12.9025H28.8476V12.2481H27.4032V11.2058H28.7927V10.5516H27.4032V9.69481H28.8476V9.04077H26.6158V12.9025Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.3847 10.8165H30.1562V9.6485H30.3975C30.8892 9.6485 31.1526 9.84597 31.1526 10.2222C31.1526 10.6087 30.8892 10.8165 30.3847 10.8165ZM31.9631 10.1802C31.9631 9.45701 31.4447 9.04077 30.5361 9.04077H29.3671V12.9025H30.1562V11.3498H30.2586L31.3459 12.9025H32.3141L31.0444 11.2749C31.6378 11.1588 31.9631 10.7711 31.9631 10.1802Z"
            fill="#1A1919"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.3892 12.9946C19.2271 12.9946 18.2856 12.0934 18.2856 10.9816C18.2856 9.86967 19.2271 8.96838 20.3892 8.96838C21.5515 8.96838 22.4929 9.86967 22.4929 10.9816C22.4929 12.0934 21.5515 12.9946 20.3892 12.9946Z"
            fill="#E6772F"
          />
          <defs>
            <clipPath id="discover-card-clip-path">
              <rect
                width="34"
                height="20"
                fill="white"
                transform="translate(3 2)"
              />
            </clipPath>
          </defs>
        </>
      ),
      amex: (
        <>
          <rect
            x="3"
            y="2"
            width="34"
            height="20"
            rx="1.61395"
            fill="#0072CE"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.3236 13.7587H31.0894C30.9662 13.7587 30.8844 13.7633 30.8154 13.8098C30.744 13.8555 30.7165 13.9234 30.7165 14.013C30.7165 14.1196 30.7768 14.1921 30.8645 14.2235C30.936 14.2482 31.0127 14.2555 31.1255 14.2555L31.4925 14.2653C31.8628 14.2744 32.1101 14.3379 32.2608 14.4927C32.2882 14.5142 32.3047 14.5384 32.3236 14.5626V13.7587ZM32.3236 15.6213C32.1591 15.8611 31.8386 15.9827 31.4047 15.9827H30.0969V15.3769H31.3994C31.5286 15.3769 31.619 15.3599 31.6734 15.3069C31.7206 15.2632 31.7535 15.1998 31.7535 15.1227C31.7535 15.0404 31.7206 14.975 31.6708 14.9358C31.6216 14.8927 31.5501 14.8731 31.4322 14.8731C30.7963 14.8516 30.0031 14.8927 30.0031 13.9987C30.0031 13.589 30.2641 13.1576 30.9747 13.1576H32.3235V12.5955H31.0703C30.6921 12.5955 30.4174 12.6858 30.2228 12.8262V12.5955H28.3692C28.0727 12.5955 27.7248 12.6688 27.5602 12.8262V12.5955H24.2501V12.8262C23.9866 12.6368 23.5421 12.5955 23.3369 12.5955H21.1535V12.8262C20.9451 12.625 20.4816 12.5955 20.1992 12.5955H17.7556L17.1964 13.1989L16.6726 12.5955H13.0224V16.5375H16.6039L17.1801 15.9247L17.7229 16.5375L19.9306 16.5395V15.6122H20.1476C20.4405 15.6167 20.786 15.6049 21.0908 15.4736V16.5375H22.9117V15.51H22.9996C23.1117 15.51 23.1227 15.5146 23.1227 15.6263V16.5374H28.6544C29.0056 16.5374 29.3727 16.4478 29.576 16.2851V16.5374H31.3306C31.6957 16.5374 32.0523 16.4863 32.3236 16.3557V15.6213ZM29.6224 14.4927C29.7543 14.6287 29.825 14.8005 29.825 15.0912C29.825 15.699 29.4441 15.9827 28.7612 15.9827H27.4423V15.3769H28.7559C28.8843 15.3769 28.9754 15.3599 29.0325 15.3069C29.0791 15.2632 29.1125 15.1998 29.1125 15.1227C29.1125 15.0404 29.0763 14.975 29.0299 14.9358C28.9781 14.8927 28.9066 14.8731 28.7887 14.8731C28.1554 14.8516 27.3624 14.8927 27.3624 13.9987C27.3624 13.5889 27.6206 13.1576 28.3305 13.1576H29.6881V13.7589H28.4459C28.3228 13.7589 28.2427 13.7635 28.1746 13.8099C28.1004 13.8557 28.0729 13.9236 28.0729 14.0132C28.0729 14.1198 28.1359 14.1923 28.2211 14.2236C28.2925 14.2484 28.3692 14.2557 28.4846 14.2557L28.8491 14.2655C29.2167 14.2744 29.4691 14.3378 29.6224 14.4927ZM23.5121 14.3182C23.4215 14.3717 23.3095 14.3763 23.1777 14.3763H22.3551V13.7418H23.1889C23.3095 13.7418 23.4302 13.7444 23.5121 13.7929C23.5999 13.8386 23.6523 13.9261 23.6523 14.047C23.6523 14.1679 23.5999 14.2653 23.5121 14.3182ZM23.9211 14.6699C24.0718 14.7253 24.195 14.8247 24.2528 14.907C24.3484 15.045 24.3622 15.1737 24.365 15.4227V15.9828H23.6851V15.6293C23.6851 15.4593 23.7015 15.2077 23.5757 15.0763C23.4767 14.9751 23.3259 14.9509 23.0789 14.9509H22.3552V15.9828H21.6748V13.1576H23.2382C23.581 13.1576 23.8307 13.1727 24.0529 13.2909C24.2666 13.4197 24.401 13.596 24.401 13.9183C24.401 14.3692 24.0993 14.5993 23.9211 14.6699ZM24.7765 13.1576H27.0366V13.7419H25.4509V14.2555H26.9979V14.8319H25.4509V15.394L27.0366 15.3966V15.9828H24.7765V13.1576ZM20.2078 14.4613H19.3327V13.7418H20.2156C20.4601 13.7418 20.6298 13.8412 20.6298 14.0882C20.6298 14.3326 20.468 14.4613 20.2078 14.4613ZM18.6582 15.7257L17.6186 14.5749L18.6582 13.4607V15.7257ZM15.9733 15.3939H14.3084V14.8318H15.7951V14.2554H14.3084V13.7418H16.0061L16.7468 14.5651L15.9733 15.3939ZM21.3568 14.0883C21.3568 14.8731 20.7695 15.0352 20.1776 15.0352H19.3327V15.9828H18.0165L17.1827 15.0475L16.3162 15.9828H13.6339V13.1576H16.3574L17.1906 14.0837L18.0519 13.1576H20.2156C20.753 13.1576 21.3568 13.3059 21.3568 14.0883Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.4031 9.9018L9.93964 8.77581L9.47881 9.9018H10.4031ZM20.6135 9.45335C20.5204 9.50967 20.4104 9.51154 20.2785 9.51154H19.4559V8.88418H20.2897C20.4077 8.88418 20.5309 8.88946 20.6109 8.93513C20.6987 8.97628 20.753 9.06385 20.753 9.18483C20.753 9.30827 20.7013 9.40761 20.6135 9.45335ZM26.482 9.9018L26.0134 8.77581L25.5473 9.9018H26.482ZM15.5428 11.1206H14.8486L14.846 8.90846L13.8641 11.1206H13.2695L12.2851 8.9065V11.1206H10.9078L10.6476 10.4906H9.23769L8.97485 11.1206H8.23938L9.452 8.2961H10.4581L11.6098 10.9703V8.2961H12.715L13.6012 10.2122L14.4153 8.2961H15.5427V11.1206H15.5428ZM18.3095 11.1206H16.0474V8.2961H18.3095V8.88426H16.7246V9.39338H18.2715V9.97234H16.7246V10.5364H18.3095V11.1206ZM21.499 9.05678C21.499 9.50711 21.1975 9.73977 21.0219 9.80963C21.17 9.86585 21.2966 9.96519 21.3568 10.0475C21.4524 10.188 21.4689 10.3135 21.4689 10.5657V11.1206H20.7859L20.7834 10.7644C20.7834 10.5944 20.7997 10.35 20.6765 10.2141C20.5775 10.1148 20.4267 10.0932 20.1829 10.0932H19.456V11.1206H18.7789V8.2961H20.3364C20.6825 8.2961 20.9374 8.30521 21.1564 8.43138C21.3706 8.55755 21.499 8.74174 21.499 9.05678ZM22.5827 11.1206H21.8917V8.2961H22.5827V11.1206ZM30.5985 11.1206H29.6389L28.3554 9.00064V11.1206H26.9763L26.7128 10.4906H25.3061L25.0505 11.1206H24.2581C23.9289 11.1206 23.5122 11.048 23.2762 10.8082C23.0382 10.5684 22.9144 10.2435 22.9144 9.72989C22.9144 9.31099 22.9884 8.92805 23.2794 8.62545C23.4984 8.40003 23.8412 8.2961 24.3078 8.2961H24.9634V8.9013H24.3216C24.0745 8.9013 23.9349 8.93794 23.8005 9.06862C23.6851 9.18755 23.6059 9.41237 23.6059 9.70842C23.6059 10.011 23.6662 10.2292 23.7921 10.3717C23.8963 10.4835 24.0857 10.5174 24.264 10.5174H24.5681L25.5225 8.29618H26.5371L27.6836 10.9677V8.29618H28.7146L29.9049 10.2633V8.29618H30.5985V11.1206ZM8.23152 11.6753H9.3885L9.64938 11.048H10.2334L10.4936 11.6753H12.7701V11.1957L12.9733 11.6774H14.155L14.3582 11.1885V11.6753H20.0157L20.013 10.6455H20.1225C20.1992 10.6482 20.2215 10.6552 20.2215 10.7814V11.6753H23.1476V11.4356C23.3836 11.5617 23.7507 11.6753 24.2337 11.6753H25.4647L25.7282 11.048H26.3122L26.5698 11.6753H28.942V11.0794L29.3012 11.6753H31.2021V7.73602H29.3209V8.20126L29.0574 7.73602H27.1271V8.20126L26.8852 7.73602H24.2777C23.8412 7.73602 23.4575 7.79677 23.1476 7.96604V7.73602H21.3482V7.96604C21.151 7.79157 20.8822 7.73602 20.5834 7.73602H14.0095L13.5684 8.75348L13.1155 7.73602H11.0449V8.20126L10.8174 7.73602H9.05149L8.23143 9.60898V11.6753H8.23152Z"
            fill="white"
          />
        </>
      ),
    }[brand]);

  const cardSVG = creditCardMap(brand);

  let additionalInfo = showPrimary && (
    <path
      d="M32.8265 1.49806L34.6197 5.65281H38.1097C38.286 5.64559 38.4603 5.69323 38.6085 5.78921C38.7568 5.88518 38.8718 6.0248 38.9378 6.18891C39.0039 6.35302 39.0177 6.5336 38.9774 6.70589C38.9371 6.87818 38.8446 7.03375 38.7127 7.15128L35.6839 9.86226L37.3619 13.7295C37.4356 13.9067 37.4521 14.1026 37.4089 14.2896C37.3657 14.4766 37.2651 14.6454 37.1213 14.772C36.9774 14.8987 36.7976 14.9769 36.6071 14.9956C36.4166 15.0143 36.225 14.9726 36.0594 14.8764L32.0085 12.5873L27.9576 14.8764C27.792 14.9726 27.6004 15.0143 27.4099 14.9956C27.2194 14.9769 27.0396 14.8987 26.8957 14.772C26.7519 14.6454 26.6513 14.4766 26.6081 14.2896C26.5649 14.1026 26.5814 13.9067 26.6551 13.7295L28.3347 9.86226L25.2872 7.15128C25.1555 7.03392 25.0631 6.87864 25.0228 6.70667C24.9824 6.5347 24.9959 6.35442 25.0616 6.19046C25.1272 6.02651 25.2417 5.88687 25.3895 5.79064C25.5372 5.69441 25.711 5.64628 25.887 5.65281H29.3786L31.175 1.49806C31.2545 1.34767 31.3734 1.22185 31.5189 1.13411C31.6644 1.04636 31.8309 1 32.0007 1C32.1705 1 32.337 1.04636 32.4825 1.13411C32.628 1.22185 32.7469 1.34767 32.8265 1.49806Z"
      fill="#FAFAFA"
      stroke="#FFB301"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  );

  if (showError) {
    additionalInfo = (
      <>
        <circle
          cx="32"
          cy="8"
          r="7.25"
          fill="#EF5259"
          stroke="white"
          strokeWidth="1.5"
        />
        <circle cx="32" cy="11" r="1" fill="white" />
        <rect x="31" y="4" width="2" height="5" rx="1" fill="white" />
      </>
    );
  }

  return (
    <svg
      width="40"
      height="24"
      viewBox="0 0 40 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {cardSVG}
      {additionalInfo}
    </svg>
  );
}
